export enum ReportTypes {
  Activity = "activity",
  Blocks = "blocks",
  SS = "ss",
}

export const Endpoint = {
  [ReportTypes.Activity]: "dns/requests-by-group",
  [ReportTypes.Blocks]: "pi/blocks-by-group",
  [ReportTypes.SS]: "ss/blocks-by-group",
};

export const EndpointsTranslationsMap = {
  [ReportTypes.Activity]: "internet_activity",
  [ReportTypes.Blocks]: "blocked_activity",
  [ReportTypes.SS]: "malware_and_phishing_blocked",
};
